import { render } from "./InfiniteLoading.vue?vue&type=template&id=10c1b49f&scoped=true"
import script from "./InfiniteLoading.vue?vue&type=script&lang=js"
export * from "./InfiniteLoading.vue?vue&type=script&lang=js"

import "./InfiniteLoading.vue?vue&type=style&index=0&id=10c1b49f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-10c1b49f"

export default script